<div class="search-box-container">

  @if(!isExpanded) {
  <div class="expand-search" #expandSearch>
      <button color="primary"
              name="expand-search-button"
              class="expand-search-button"
              matRipple
              (click)="onExpandClick()">
        <app-fn-ui-icon icon="search" #searchIcon></app-fn-ui-icon>
      </button>
  </div >
  }

  @if(isExpanded) {
    <div class="search-header" [class.show-border]="selectedItem.name === 'messages' && focusedSearchEnabled && isExpanded">
      <div class="search-box" #searchBox>
        <app-search-menu [items]="items"
                         [selectedItem]="selectedItem"
                         (menuItemClicked)="onMenuItemClick($event)">
        </app-search-menu>

        <app-search-input [selectedItem]="selectedItem"
                          [readOnly]="selectedItem.name === 'messages' && focusedSearchEnabled"
                          (searchTriggered)="onSearchTrigger($event)">
        </app-search-input>
      </div>

      <button mat-icon-button color="primary"
              azure-id="collapse-search"
              name="collapse-search-button"
              class="collapse-search-button"
              (click)="onCollapseClick()" #collapseButton>
        <app-fn-ui-icon icon="close"></app-fn-ui-icon>
      </button>
  </div>
  }


  @if (selectedItem.name === "messages" && focusedSearchEnabled && isExpanded) {
  <div class="search-body">
    <app-quick-search-modal (onCloseClicked)="onQuickSearchModalClose($event)"></app-quick-search-modal>
  </div>
  }
</div>

